var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.9482 177.6263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H6.3853c40.8269,0,78.171,16.06,103.9055,44.6968,22.6387,25.154,34.6352,58.6283,34.6352,95.9724v11.416c8.1267-8.1267,11.8031-11.803,13.9315-13.738,10.6421-9.6746,10.6421-9.6746,16.4468-15.2859l4.6439,5.0308c-22.4452,26.1215-22.4452,26.1215-39.4725,49.5342-17.0274-23.4127-17.0274-23.4127-39.4725-49.5342l4.6438-5.0308c5.8048,5.6113,5.8048,5.6113,16.4469,15.2859,1.9349,1.7415,5.2243,5.0309,13.9314,13.738V140.8627c0-41.02-14.7054-75.8492-41.7944-100.2292C70.6248,19.5428,39.4725,8.1267,5.8048,8.1267H0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBend);
export default __webpack_public_path__ + "static/media/arrow-bend.16116172a100a36fc814aadccd118f34.svg";
export { ForwardRef as ReactComponent };